export default {
  bannedUsers: [],
  bannedUser: undefined,
};
